import { Button } from 'devextreme-react/button';
import React, { useState } from "react";
import { useSelector } from 'react-redux';

import { thuPhiApi } from '../../../api/thuPhiApi';
import { showNotify } from '../../../helpers/toast';
import { NamHocTruongKhoiHeFilter } from '../../../models/namHocTruongKhoiHeFilter';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { sf_mucphaithu } from '../../../models/response/thu-phi/sf_mucphaithu';
import { AddKhoanNopModalDefault } from '../../add-khoanop-modal';
import { RootState } from '../../../state/reducers';

export type ThuPhiAddKhoanNopBtnProps = {
    disabled: boolean,
    sf_khoannop_ids_added: number[],
    filter: NamHocTruongKhoiHeFilter,
    nam_hoc: string,
    sf_mucphaithu: sf_mucphaithu,
    ts_hocsinh_id: number,
    onChanged: () => void
}
const ThuPhiAddKhoanNopBtn = (props: ThuPhiAddKhoanNopBtnProps) => {
    const [isShowPopUp, setIsShowPopUp] = useState<boolean>(false);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const { ts_hocsinh_viewmodel } = useSelector((x: RootState) => x.hocSinhProfile);

    const handleAddKhoanNop = async (data: any) => {
        setIsSaving(true)
        const res: IBaseResponeModel = await thuPhiApi.insert_from_khoannop({
            nam_hoc: props.nam_hoc,
            sf_mucphaithu_id: props.sf_mucphaithu.id,
            is_tinh_mien_giam: data.is_calculate_miengiam,
            sf_mucthuphis: data.sf_mucthuphis.map((x: any) => {
                return {
                    id: 0,
                    sf_mucthuphi_id: x.sf_khoannop_id,
                    so_tien_phai_nop: Number(x.so_tien_phai_nop ?? x.so_tien ?? 0),
                    ghi_chu: x.ghi_chu || ""
                }
            }),
            ts_hocsinh_id: props.ts_hocsinh_id
        })
        setIsSaving(false)
        if (res.is_success) {
            showNotify({ message: "Đã thêm thành công", type: "success" })
            setIsShowPopUp(false);
            props.onChanged();
        } else {
            showNotify({ message: res.message || "Có lỗi xảy ra", type: "error" });
            props.onChanged();
        }
    }
    return (
        <>
            <Button
                text="Thêm khoản nộp"
                type="default"
                stylingMode="text"
                icon="plus"
                id='btnAddKhoanNop'
                className="p-btn-devextreme"
                disabled={props.disabled}
                onClick={() => {
                    setIsShowPopUp(true);
                }}
            />
            {isShowPopUp &&
                <AddKhoanNopModalDefault
                    sf_bom_id={0}
                    sf_khoannop_ids_added={props.sf_khoannop_ids_added}
                    onCancel={() => {
                        setIsShowPopUp(false)
                    }}
                    onSelected={handleAddKhoanNop}
                    isSaving={isSaving}
                    filter={{
                        nam_hoc: props.filter.nam_hoc,
                        dm_he_id: props.filter.dm_he_id,
                        dm_truong_id: props.filter.dm_truong_id,
                        dm_khoi_id: props.filter.dm_khoi_id
                    }}
                    ts_hocsinh_id={props.ts_hocsinh_id}
                    nam_nhap_hoc={ts_hocsinh_viewmodel?.nam_nhap_hoc}
                    sf_mucphaithu_id={props.sf_mucphaithu.id}
                    
                />
            }
        </>
    );
}
export default ThuPhiAddKhoanNopBtn